// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "activity-" + (chunkId === 184 ? "dashboard-lazy" : chunkId) + ".js?v=" + {"184":"b02fb3ff32afd042fb71","620":"85b59bf04dde1e9594fc"}[chunkId] + "";
};